import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

export const FILTERS_PROGRAM_ARTICLE_DASHBOARD_ACTIONS = {
  SET_DASHBOARD_DATES: 'SET_DASHBOARD_DATES',
  SET_DASHBOARD_FILTERS: 'SET_DASHBOARD_FILTERS'
};

export interface IFiltersProgramArticleDashboard {
  startDate: Date;
  endDate: Date;
  selectedChannel: number;
  defaultDestination: string;
  midnightMode: boolean;
}

@Injectable()
export class FiltersProgramArticleDashboard {

  constructor(private store: Store<IFiltersProgramArticleDashboard>) { }

  setDates(startDate: Date, endDate: Date, midnightMode: boolean) {
    this.store.dispatch({ type: FILTERS_PROGRAM_ARTICLE_DASHBOARD_ACTIONS.SET_DASHBOARD_DATES, payload: { startDate, endDate, midnightMode } });
  }

  setFilters(filters: IFiltersProgramArticleDashboard) {
    this.store.dispatch({ type: FILTERS_PROGRAM_ARTICLE_DASHBOARD_ACTIONS.SET_DASHBOARD_FILTERS, payload: filters });
  }
}



// WEBPACK FOOTER //
// ./src/app/store/actions/filters-program-article-dashboard.actions.ts